<template>
	<div class="resource-type-link margin-bottom-xs-2" v-if="resource">
		<a
			:href="resource.link.url"
			class="pem-btn pem-btn-primary pem-btn-block"
			target="blank"
			><span v-html="resource.link.title"></span
			><Icon class="margin-left-xs-1 icon-white" :icon="'link'"
		/></a>
	</div>
</template>
<script>
import Icon from "./../partials/Icon.vue";
export default {
	name: "ResourceTypeLink",
	props: [],
	components: { Icon },
	computed: {
		resource() {
			return this.$store.state.activeResource;
		}
	},
	methods: {},
	mounted() {}
};
</script>